import { CurrentUser } from "app/shared/model/CurrentUser";
import { getLocalApi } from "./localApi";
import apiConfig from "app/api/apiConfig.json";

export async function getCurrentUser() {
    const localApi = await getLocalApi();
    return await localApi.fetchSingle(apiConfig.user_get_user, mapCurrentUser, "Failed to fetch current user");    
}

function mapCurrentUser(currentUser: any): CurrentUser {
    return currentUser as CurrentUser;
}
